// export const API_BASE_URL = 'http://localhost:8000';
// export const API_BASE_URL = 'https://dev-api.playaar.pk';
export const API_BASE_URL = 'https://api.playaar.pk';
export const GOOGLE_CLIENT_ID = '';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCMijnpIG-A7V0WeMMDcUP1sbnqw6XKtwY';
